import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { IoMdTrophy as TrophyIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  icon: {
    composes: ['is-absolute'],
    left: 0,
    top: 0,
  },
  score: {
    composes: ['is-relative', 'no-overflow'],
    height: '100%',
    top: 0,
    width: '100%',
  },
  trophytrack: {
    composes: ['is-overlay'],
    zIndex: 1,
  },
});

const TrophyTrackComponent = React.memo(({ percent }) => {
  const classes = useStyles();
  const height = `${100 - percent}%`;
  return (
    <div
      className={classnames(
        classes.trophytrack,
        'smart-maps-trophies-overall-trophy-track'
      )}
      style={{ height }}>
      <div className={classes.score}>
        <TrophyIcon className={classes.icon} size={40} />
      </div>
    </div>
  );
});

TrophyTrackComponent.propTypes = {
  percent: PropTypes.number.isRequired,
};

TrophyTrackComponent.displayName = 'TrophyTrackComponent';

export default TrophyTrackComponent;
